import { PageNameType } from './clientConfiguration/clientConfigurationSlice';

export const apiVersion = {
 results: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  approveResult: 2,
  getResultPictures: 2,
  getTableExcel: 2,
 },
 customers: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 vehicles: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 products: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 drivers: {
  getTable: 2,
  getItem: 2,
  createItem: 2,
  updateItem: 2,
  deleteItem: 2,
  getTableStructure: 2,
  getItemDocuments: 2,
  uploadItemDocuments: 2,
  deleteItemDocument: 2,
  getTableExcel: 2,
 },
 destPoint: {
  getTable: 1,
  getItem: 1,
  createItem: 1,
  updateItem: 1,
  deleteItem: 1,
  getTableStructure: 1,
  // these are not used in destPoint
  getItemDocuments: 1,
  uploadItemDocuments: 1,
  deleteItemDocument: 1,
  getTableExcel: 1,
 },
};

export const getApiVersion = (
 table: PageNameType,
 action: keyof (typeof apiVersion)[typeof table],
) => {
 const version = apiVersion[table as keyof typeof apiVersion][action];
 return version;
};
